import React, { useState, Fragment } from 'react'
import { Formik } from 'formik'
import { ModalContent } from 'pobble-components/dist/modal'
import styles from './slide-form.styles'
import injectSheet from 'react-jss'
import FormRow from '../../../common/form-elements/form-row/form-row'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import FormLabel from 'pobble-components/dist/form-elements/form-label'
import CharactersCount from 'pobble-components/dist/form-elements/characters-count'
import {
  StickyEditor,
  EditorState,
  Controls,
  createStateFromHtml,
  stateToHTML
} from '../../../editor'
import * as Yup from 'yup'

const TITLE_MAX_LENGTH = 100
const TEXT_MAX_LENGTH = 1500

const SlideForm = ({ classes, initialValues, onSubmit, footer }) => {
  const [editorState, setEditorState] = useState(
    !initialValues.text
      ? EditorState.createEmpty()
      : createStateFromHtml(initialValues.text)
  )
  return (
    <Formik
      onSubmit={values =>
        onSubmit({
          ...values,
          text: editorState.getCurrentContent().getPlainText(),
          html: stateToHTML(editorState)
        })
      }
      initialValues={initialValues}
      validationSchema={Yup.object().shape({
        text: Yup.string().max(TEXT_MAX_LENGTH)
      })}>
      {formikProps => {
        const {
          handleSubmit,
          handleBlur,
          handleChange,
          values,
          errors,
          setFieldValue
        } = formikProps
        return (
          <form onSubmit={handleSubmit} className="metrics__slide-form">
            <ModalContent legacy className={classes.modalContent}>
              <FormRow first>
                <FormLabel small spaceBetween htmlFor="createImageSlideTitle">
                  Title
                  <CharactersCount
                    value={values.title}
                    max={TITLE_MAX_LENGTH}
                  />
                </FormLabel>
                <FormInput
                  placeholder="eg. Roman Empire"
                  name="title"
                  value={values.title}
                  id="createImageSlideTitle"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  autoFocus={true}
                  maxLength={TITLE_MAX_LENGTH}
                />
              </FormRow>
              <FormRow>
                <FormLabel small spaceBetween htmlFor="createImageSlideText">
                  Description
                  <CharactersCount value={values.text} max={TEXT_MAX_LENGTH} />
                </FormLabel>
                <StickyEditor
                  maxLength={TEXT_MAX_LENGTH}
                  error={!!errors.text}
                  placeholder="eg. The Roman Empire was the post-Roman Republic period ..."
                  controls={
                    <Fragment>
                      <Controls.Bold />
                      <Controls.Italic />
                      <Controls.Underline />
                      <Controls.Separator />
                      <Controls.UnorderedList />
                      <Controls.OrderedList />
                    </Fragment>
                  }
                  editorState={editorState}
                  onChange={newState => {
                    const plainText = newState
                      .getCurrentContent()
                      .getPlainText()
                    setFieldValue('text', plainText)
                    setEditorState(newState)
                  }}
                />
              </FormRow>
            </ModalContent>
            {footer(formikProps)}
          </form>
        )
      }}
    </Formik>
  )
}

export default injectSheet(styles)(SlideForm)
